import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { getI18n } from 'react-i18next';

import api from '@api';
import { getCurrentUser, login, logout } from './auth.actions';
import { LoadersNames } from '../ui/ui.actions';
import { Credentials } from '../types';
import { getToken, removeToken, storeToken } from '../../frontendUtils/local-storage';
import { entitiesActions, uiActions } from '../actions';
import { putError } from '@utils/notificationUtils';
import { getLocale } from './auth.selector';
import { updateProfile } from '../profile/profile.actions';

export function* loginSaga({ payload }: Action<Credentials>) {
  yield put(uiActions.showLoader(LoadersNames.loggingIn));

  try {
    const result = yield call(api.auth.loginMutation, { email: payload.username, password: payload.password });
    storeToken(result.token);
    yield put(login.done({ params: {}, result }));
  } catch (err) {
    yield putError(err, 'app:msg_title_login_error', '');
  }
  yield put(uiActions.hideLoader(LoadersNames.loggingIn));
}

export function* getCurrentUserSaga() {
  yield put(uiActions.showLoader(LoadersNames.loggingIn));

  try {
    const result = yield call(api.auth.currentUserQuery);
    const token = getToken();
    yield put(login.done({ params: {}, result: { token, user: result } }));
  } catch (err) {
    yield putError(err, 'app:msg_title_login_error', '');
  }
  yield put(uiActions.hideLoader(LoadersNames.loggingIn));
}

const changeLanguage = (i18nInstance: any, locale) =>
  new Promise((resolve) => {
    i18nInstance.changeLanguage(locale, resolve);
  });

export function* setLanguageSaga() {
  try {
    const lng = yield select(getLocale);
    const i18n = yield call(getI18n);
    yield call(changeLanguage, i18n, lng);
  } catch (err) {
    yield putError(err, 'app:msg_title_error', 'app:error_user_language');
  }
}

function* logoutSaga() {
  removeToken();
}

export function* afterLoginSaga() {
  yield put(entitiesActions.fetchAuthorList.started({}));
  yield put(entitiesActions.fetchSerieList.started({}));
}

export function* watchAuthSaga() {
  yield all([
    yield takeLatest(login.started, loginSaga),
    yield takeLatest(login.done, afterLoginSaga),
    yield takeLatest(login.done, setLanguageSaga),
    yield takeLatest(getCurrentUser.started, getCurrentUserSaga),
    yield takeLatest(getCurrentUser.done, setLanguageSaga),
    yield takeLatest(updateProfile.done, setLanguageSaga),
    yield takeLatest(logout, logoutSaga),
  ]);
}
